import { ReferralCode } from "../entities/referralCode";
import { OnboardingRepository } from "../repositories/OnboardingRepository";

export class GetReferralCode {
    constructor(private repository: OnboardingRepository) {}
    execute(): Promise<ReferralCode> {
        return this.repository.getReferralCode();
    }
}
